import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { Formik } from "formik";
import PageTitle from "../../general/pageTitle";
import CalendarForm, { reindexTerms } from "./CalendarForm";
import { updateCalendar } from "../../../services/calendarServices";

const validationSchema = yup.object().shape({
  year: yup.string().required("Academic year is required"),
  info: yup.string().required("Info label is required"),
  sortOrder: yup.number().min(1).required("Display order is required"),
  terms: yup
    .array()
    .of(
      yup.object().shape({
        sem: yup.string().required("Semester name is required"),
        calendar: yup
          .array()
          .of(
            yup.object().shape({
              opp: yup.string().required("Operation is required"),
              beginDate: yup.string().required("Beginning date is required"),
            })
          )
          .min(1, "Add at least one calendar row"),
      })
    )
    .min(1, "Add at least one semester"),
});

function EditCalendar() {
  const { state } = useLocation();
  const navigate = useNavigate();

  if (!state?.calendar) {
    return (
      <div className="p-6 text-center text-gray-600">
        No calendar selected.{" "}
        <button
          type="button"
          className="text-blue-600 underline"
          onClick={() => navigate("/mycalendar")}
        >
          Go back
        </button>
      </div>
    );
  }

  const calendar = state.calendar;

  return (
    <div>
      <PageTitle title="Edit academic calendar" subTitle="calendar" />
      <div className="flex flex-col justify-center p-4">
        <Formik
          initialValues={{
            year: calendar.year || "",
            info: calendar.info || "Academic calendar",
            sortOrder: calendar.sortOrder || 1,
            status: calendar.status || "published",
            terms: reindexTerms(calendar.terms || []),
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, actions) => {
            try {
              await updateCalendar({
                _id: calendar._id,
                calendarId: calendar.calendarId,
                ...values,
                terms: reindexTerms(values.terms),
              });
              navigate("/mycalendar");
            } catch (err) {
              actions.setSubmitting(false);
              alert("Failed to update calendar. Please try again.");
            }
          }}
        >
          {(formik) => (
            <CalendarForm
              title={`Edit ${calendar.year}`}
              cancelPath="/mycalendar"
              {...formik}
            />
          )}
        </Formik>
      </div>
    </div>
  );
}

export default EditCalendar;
